import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from 'material-ui/styles';
import Typography from "material-ui/Typography";
import TextField from 'material-ui/TextField';
import { FollowCallQuestionnaire } from "../../../constants/Questionnaire";
import { validateQuestionnaire } from "../../../utils/validator";
import Wrapper from '../common/Wrapper';
import AnswerCheckbox from "../parts/AnswerCheckbox";
import AnswerRadio from "../parts/AnswerRadio";
import Button from '../../Parts/Button';
import Loader from "../../Parts/Loader";

const styles = () => ({
  main: {
    width: '100%',
    boxSizing: 'border-box',
    boxShadow: '0px 0px 10px #00000026',
    borderRadius: '5px',
    padding: '40px',
    marginBottom: '60px',
  },

  title: {
    fontSize: 28,
    textAlign: 'center',
    paddingBottom: 40,
    borderBottom: '1px solid #5F6368',
    marginBottom: 30,
  },

  questionContainer: {
    marginTop: 30,
  },

  questionText: {
    fontSize: 17,
    fontWeight: 'bold',
  },

  questionItem: {
    marginTop: 20,
    marginBottom: 5,
    fontSize: 17,
  },

  pointLine: {
    alignItems: 'center',
    justifyContent: 'flex-start',
    borderBottom: '2px solid #DBDFE1',
    paddingBottom: '15px',
    marginBottom: '25px',
    position: 'relative',

    '&:before': {
      content: '""',
      display: 'block',
      width: '60px',
      borderBottom: '2px solid #195AFF',
      position: 'absolute',
      bottom: '-2px',
      left: 0,
    },
  },

  textDanger: {
    color: "#FF0000",
  },

  tooltip: {
    backgroundColor: '#d32f2f',
    width: '100%',
    maxWidth: '335px',
  },
});

class FollowCallAppointment extends React.Component {
  state = {
    questionnaire: {
      answerer: {
        name: '', // 名前
        email: '', // メールアドレス
      },
      operator_feedback: {
        good: [], // フォローコールオペレーターについて良かった点（複数選択）
        improving: [], // フォローコールオペレーターについて改善が必要だと感じた点（複数選択）
        other_good: '', // 良かった点で「その他」を選択された場合に記入
        other_improving: '' // 改善が必要だと感じた点で「その他」を選択された場合に記入
      },
      appointment_feedback: {
        target_select: '', // 商談のターゲットの選定
        target_select_detail: '', // 上記の理由
        target_interest_level: '', // 商談相手の関心度
        target_interest_level_detail: '', // 上記の理由
        improving_quality: [], // 商談の質向上のために改善が必要だと感じた点（複数選択）
        other_improving_quality: '' //商談の質向上の改善で「その他」を選択された場合に記入
      },
      other: {
        opinion: '', // 上記の点以外で、ご意見・ご質問など
      },
    },
    error: {},
    saveBtnPressed: false,
    message: "",
  };

  checkNoError = (error) => {
    if (Object.keys(error).length === 0) {
      return true;
    }

    return Object.keys(error).every(key => Object.keys(error[key]).length === 0);
  }

  componentDidMount() {
    this.props.getUserInfo();
    if (this.props.match && this.props.match.params && this.props.match.params.id) {
      this.props.getTimelineStatusById(this.props.match.params.id)
    }
  }

  componentDidUpdate(prevProps) {
    if (prevProps.error !== this.props.error && this.props.error !== null) {
      if (typeof this.props.error === "object" && Object.keys(this.props.error).length > 0) {
        const formattedError = {};
        Object.entries(this.props.error).forEach(([key, value]) => {
          const [category, field] = key.split('.');
          if (!formattedError[category]) {
            formattedError[category] = {};
          }
          formattedError[category][field] = value;
        });

        this.setState({
          error: {
            ...this.state.error,
            ...formattedError,
          },
          message: this.checkNoError(formattedError) ? '' : 'エラー項目を確認してください。',
        });
      } else if (typeof this.props.error === "string") {
        this.displayNotification(this.props.error);
      }
    }
  }

  displayNotification = (message) => {
    this.setState({
      message: message,
    });
  };

  handleChange = (section, itemId, value) => {
    this.setState((prevState) => ({
      questionnaire: {
        ...prevState.questionnaire,
        [section]: {
          ...prevState.questionnaire[section],
          [itemId]: value,
        },
      },
    }), () => {
      if (this.state.saveBtnPressed) {
        const { questionnaire } = this.state;
        this.validateForm(questionnaire);
      }
    });
  };

  handleCheckboxChange = (section, itemId, value) => {
    this.setState((prevState) => {
      const selectedOptions = [...prevState.questionnaire[section][itemId]];

      // チェックボックスの状態を更新
      if (selectedOptions.includes(value)) {
        // チェックを外す
        const index = selectedOptions.indexOf(value);
        selectedOptions.splice(index, 1);
      } else {
        // チェックをつける
        selectedOptions.push(value);
      }

      return {
        questionnaire: {
          ...prevState.questionnaire,
          [section]: {
            ...prevState.questionnaire[section],
            [itemId]: selectedOptions,
          },
        },
      };
    }, () => {
      if (this.state.saveBtnPressed) {
        const { questionnaire } = this.state;
        this.validateForm(questionnaire);
      }
    });
  };

  validateForm = () => {
    let { questionnaire, error } = this.state;
    questionnaire.answerer.email = this.props.user.email;

    error = validateQuestionnaire(questionnaire);
    this.setState({
      error: error,
      message: this.checkNoError(error) ? '' : 'エラー項目を確認してください。',
      saveBtnPressed: true,
    });

    return error;
  };

  handleSubmit = () => {
    const error = this.validateForm();
    if (this.checkNoError(error)) {
      this.props.postFollowCallAppointment(this.props.timelineStatus.id, this.state.questionnaire);
    }
  };

  render() {
    const { classes, user, isLoadingUser, isLoadingStatuses, isSaving, timelineStatus } = this.props;
    const { questionnaire, error } = this.state;
    const followCallQuestionnaire = FollowCallQuestionnaire.APPOINTMENT;

    if (isLoadingUser || isLoadingStatuses) {
      return (
        <Wrapper message={this.state.message}>
          <Loader type="color" size="large" />
        </Wrapper>
      );
    } else if (!user || !timelineStatus) {
      return (
        <Wrapper message={this.state.message}>
          <div className={classes.main} style={{ textAlign: 'center' }}>
            <Typography variant="subheading">いつもご利用いただき、誠にありがとうございます。</Typography>
            <Typography variant="subheading">該当のデータが存在しませんでした。</Typography>
            <Button
              text="ホームへ戻る"
              handleClickButton={this.props.goToDashboard}
              style={{ margin: '40px auto', width: 250 }}
            />
          </div>
        </Wrapper>
      );
    } else {
      return (
        <Wrapper message={this.state.message}>
          <div className={classes.main}>
            <div className={classes.title}>サービス向上に関するアンケート</div>
            <Typography variant="subheading">いつもご利用いただき、誠にありがとうございます。</Typography>
            <Typography variant="subheading">
              {timelineStatus.follow_call_order_address && timelineStatus.follow_call_order_address.name ? timelineStatus.follow_call_order_address.company + 'の' : ''}
              {timelineStatus.follow_call_order_address && timelineStatus.follow_call_order_address.name ? timelineStatus.follow_call_order_address.name + '様' : ''}
              との商談はいかがでしたか？
            </Typography>
            <Typography variant="subheading">より良いサービスを提供するため、アンケートを実施させていただいております。</Typography>
            <Typography variant="subheading" style={{ marginBottom: 10 }}>お忙しいところ恐れ入りますが、ご協力のほどよろしくお願い申し上げます。</Typography>
            <Typography variant="subheading">このアンケートの所要時間は5分程度です。</Typography>
            <Typography variant="subheading">お寄せいただいた情報はサービスの改善のために使用されます。</Typography>
            <Typography variant="subheading">「*」は必須項目です。</Typography>

            <div className={classes.questionContainer}>
              <div className={classes.pointLine}>
                <div className={classes.questionText}>Q1. ご回答されるお客様情報</div>
              </div>
              <div className={classes.questionItem}>1. 名前<span className={classes.textDanger}> *</span></div>
              <TextField
                id="name"
                value={questionnaire.answerer.name}
                InputProps={{
                  disableUnderline: true,
                }}
                error={error.answerer && error.answerer.hasOwnProperty("name")}
                helperText={error.answerer ? error.answerer.name : ''}
                onChange={(e) => this.handleChange('answerer', 'name', e.target.value)}
                fullWidth
              />
              <div className={classes.questionItem}>2. メールアドレス</div>
              <TextField
                id="email"
                value={user ? user.email : ''}
                InputProps={{
                  disableUnderline: true,
                }}
                error={error.answerer && error.answerer.hasOwnProperty("email")}
                helperText={error.answerer ? error.answerer.email : ''}
                disabled={true}
                onChange={(e) => this.handleChange('answerer', 'email', e.target.value)}
                fullWidth
              />
            </div>
            <div className={classes.questionContainer}>
              <div className={classes.pointLine}>
                <div className={classes.questionText}>Q2. フォローコールのオペレーターについて</div>
              </div>
              <div className={classes.questionItem}>1. フォローコールオペレーターについて良かった点を選択してください<span className={classes.textDanger}> *</span> （複数選択可）</div>
              <AnswerCheckbox
                options={followCallQuestionnaire.OPERATOR_FEEDBACK.GOOD.options}
                select={(value) => this.handleCheckboxChange('operator_feedback', 'good', value)}
                set={questionnaire.operator_feedback.good}
                error={error.operator_feedback && error.operator_feedback.hasOwnProperty("good")}
                errorText={error.operator_feedback ? error.operator_feedback.good : ''}
              />
              <div className={classes.questionItem}>「その他」を選択された場合にご記入ください。</div>
              <TextField
                id="other_good"
                value={questionnaire.operator_feedback.other_good}
                InputProps={{
                  disableUnderline: true,
                }}
                error={error.operator_feedback && error.operator_feedback.hasOwnProperty("other_good")}
                helperText={error.operator_feedback ? error.operator_feedback.other_good : ''}
                onChange={(e) => this.handleChange('operator_feedback', 'other_good', e.target.value)}
                fullWidth
              />
              <div className={classes.questionItem}>2. フォローコールオペレーターについて改善が必要だと感じた点を選択してください<span className={classes.textDanger}> *</span> （複数選択可）</div>
              <AnswerCheckbox
                options={followCallQuestionnaire.OPERATOR_FEEDBACK.IMPROVING.options}
                select={(value) => this.handleCheckboxChange('operator_feedback', 'improving', value)}
                set={questionnaire.operator_feedback.improving}
                error={error.operator_feedback && error.operator_feedback.hasOwnProperty("improving")}
                errorText={error.operator_feedback ? error.operator_feedback.improving : ''}
              />
              <div className={classes.questionItem}>「その他」を選択された場合にご記入ください。</div>
              <TextField
                id="other_improving"
                value={questionnaire.operator_feedback.other_improving}
                InputProps={{
                  disableUnderline: true,
                }}
                error={error.operator_feedback && error.operator_feedback.hasOwnProperty("other_improving")}
                helperText={error.operator_feedback ? error.operator_feedback.other_improving : ''}
                onChange={(e) => this.handleChange('operator_feedback', 'other_improving', e.target.value)}
                fullWidth
              />
            </div>
            <div className={classes.questionContainer}>
              <div className={classes.pointLine}>
                <div className={classes.questionText}>Q3. 商談の質について</div>
              </div>
              <div className={classes.questionItem}>1. 商談のターゲットの選定について<span className={classes.textDanger}> *</span></div>
              <AnswerRadio
                options={followCallQuestionnaire.APPOINTMENT_FEEDBACK.TARGET_SELECT.options}
                select={(value) => this.handleChange('appointment_feedback', 'target_select', value)}
                checkedValue={questionnaire.appointment_feedback.target_select}
                error={error.appointment_feedback && error.appointment_feedback.hasOwnProperty("target_select")}
                errorText={error.appointment_feedback ? error.appointment_feedback.target_select : ''}
              />
              <div className={classes.questionItem}>2. 上記の理由をお聞かせください。</div>
              <TextField
                id="target_select_detail"
                value={questionnaire.appointment_feedback.target_select_detail}
                InputProps={{
                  disableUnderline: true,
                }}
                error={error.appointment_feedback && error.appointment_feedback.hasOwnProperty("target_select_detail")}
                helperText={error.appointment_feedback ? error.appointment_feedback.target_select_detail : ''}
                onChange={(e) => this.handleChange('appointment_feedback', 'target_select_detail', e.target.value)}
                className={classes.input}
                fullWidth
              />
              <div className={classes.questionItem}>3. 商談相手の関心度について<span className={classes.textDanger}> *</span></div>
              <AnswerRadio
                options={followCallQuestionnaire.APPOINTMENT_FEEDBACK.TARGET_INTEREST_LEVEL.options}
                select={(value) => this.handleChange('appointment_feedback', 'target_interest_level', value)}
                checkedValue={questionnaire.appointment_feedback.target_interest_level}
                error={error.appointment_feedback && error.appointment_feedback.hasOwnProperty("target_interest_level")}
                errorText={error.appointment_feedback ? error.appointment_feedback.target_interest_level : ''}
              />
              <div className={classes.questionItem}>4. 上記の理由をお聞かせください。</div>
              <TextField
                id="target_interest_level_detail"
                value={questionnaire.appointment_feedback.target_interest_level_detail}
                InputProps={{
                  disableUnderline: true,
                }}
                error={error.appointment_feedback && error.appointment_feedback.hasOwnProperty("target_interest_level_detail")}
                helperText={error.appointment_feedback ? error.appointment_feedback.target_interest_level_detail : ''}
                onChange={(e) => this.handleChange('appointment_feedback', 'target_interest_level_detail', e.target.value)}
                fullWidth
              />
              <div className={classes.questionItem}>5. 商談の質向上のために改善が必要だと感じた点を選択してください<span className={classes.textDanger}> *</span> （選択式の回答）</div>
              <AnswerCheckbox
                options={followCallQuestionnaire.APPOINTMENT_FEEDBACK.IMPROVING_QUALITY.options}
                select={(value) => this.handleCheckboxChange('appointment_feedback', 'improving_quality', value)}
                set={questionnaire.appointment_feedback.improving_quality}
                error={error.appointment_feedback && error.appointment_feedback.hasOwnProperty("improving_quality")}
                errorText={error.appointment_feedback ? error.appointment_feedback.improving_quality : ''}
              />
              <div className={classes.questionItem}>「その他」を選択された場合にご記入ください。</div>
              <TextField
                id="other_improving_quality"
                value={questionnaire.appointment_feedback.other_improving_quality}
                InputProps={{
                  disableUnderline: true,
                }}
                error={error.appointment_feedback && error.appointment_feedback.hasOwnProperty("other_improving_quality")}
                helperText={error.appointment_feedback ? error.appointment_feedback.other_improving_quality : ''}
                onChange={(e) => this.handleChange('appointment_feedback', 'other_improving_quality', e.target.value)}
                fullWidth
              />
            </div>
            <div className={classes.questionContainer}>
              <div className={classes.pointLine}>
                <div className={classes.questionText}>Q4. その他</div>
              </div>
              <div className={classes.questionItem}>上記の点以外で、ご意見・ご質問などありましたらご記入ください。</div>
              <TextField
                id="opinion"
                value={questionnaire.other.opinion}
                InputProps={{
                  disableUnderline: true,
                }}
                error={error.other && error.other.hasOwnProperty("opinion")}
                helperText={error.other ? error.other.opinion : ''}
                onChange={(e) => this.handleChange('other', 'opinion', e.target.value)}
                fullWidth
              />
            </div>
            <Button
              text="回答を送信"
              handleClickButton={this.handleSubmit}
              loading={isSaving}
              disabled={!this.checkNoError(error)}
              style={{ margin: '30px auto 0 auto', width: '185px' }}
            />
          </div>
        </Wrapper>
      )
    }
  }
}

FollowCallAppointment.propTypes = {
  classes: PropTypes.object.isRequired,
  user: PropTypes.object,
  isLoadingUser: PropTypes.bool,
  timelineStatus: PropTypes.object,
  isLoadingStatuses: PropTypes.bool,
  isSaving: PropTypes.bool,
  error: PropTypes.oneOfType([
    PropTypes.object,
    PropTypes.string,
  ]),
  getUserInfo: PropTypes.func.isRequired,
  match: PropTypes.object,
  getTimelineStatusById: PropTypes.func.isRequired,
  postFollowCallAppointment: PropTypes.func.isRequired,
  goToDashboard: PropTypes.func.isRequired,
};

export default withStyles(styles)(FollowCallAppointment);



// WEBPACK FOOTER //
// ./src/components/Questionnaire/pages/FollowCallAppointment.jsx